module.exports = __webpack_public_path__ + "img/1009a_3.3ca5f03f.jpg";